<header>
  <div class="container-xl">
      <div class="row align-items-center logo-row">
        <div class="col ref-header-logo">
            <a href="https://www.unitedconcordia.com/">
                <img src="assets/img/uc-header.png" alt="United Concordia Dental logo" width="290px" height="80px">
            </a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row align-items-center heading-banner">
        <h1 class="display-4 col heading-title text-center">
          Update Provider Information
        </h1>
      </div>
    </div>
  <app-error-banner></app-error-banner>  
</header>
